import { lazy } from 'react'

import {
  TO_ACCESSIBILITY,
  TO_COOKIE_POLICY_LIST,
  TO_ERROR_404,
  TO_ERROR_500,
  TO_FASTQ_S1,
  TO_GENER_S1,
  TO_GENER_S2,
  TO_GENER_S3,
  TO_GENER_S4,
  TO_INTRO_S0,
  TO_INTRO_S1,
  TO_INTRO_S2,
  TO_INTRO_S2_OLD,
  TO_TRADI_S1,
  TO_TRADI_S2,
  TO_TRADI_S3,
  TO_TRADI_S4,
  TO_TRADI_S5,
} from './'

const IntroS0 = lazy(() => import('src/containers/intro-s0/intro-s0'))
const IntroS1 = lazy(() => import('src/containers/intro-s1/intro-s1'))
const IntroS2Old = lazy(() => import('src/containers/intro-s2-old/intro-s2-old'))
const IntroS2 = lazy(() => import('src/containers/intro-s2/intro-s2'))
const TradiS1 = lazy(() => import('src/containers/tradi-s1/tradi-s1'))
const TradiS2 = lazy(() => import('src/containers/tradi-s2/tradi-s2'))
const TradiS3 = lazy(() => import('src/containers/tradi-s3/tradi-s3'))
const TradiS4 = lazy(() => import('src/containers/tradi-s4/tradi-s4'))
const TradiS5 = lazy(() => import('src/containers/tradi-s5/tradi-s5'))
const FastqS1 = lazy(() => import('src/containers/fastq-s1/fastq-s1'))
const GenerS1 = lazy(() => import('src/containers/gener-s1/gener-s1'))
const GenerS2 = lazy(() => import('src/containers/gener-s2/gener-s2'))
const GenerS3 = lazy(() => import('src/containers/gener-s3/gener-s3'))
const GenerS4 = lazy(() => import('src/containers/gener-s4/gener-s4'))
const CookiePolicy = lazy(() => import('src/containers/cookie-policy/cookie-policy'))
const Accessibility = lazy(() => import('src/containers/accessibility/accessibility'))
const Error404 = lazy(() => import('src/containers/error-404/error-404'))
const Error500 = lazy(() => import('src/containers/error-500/error-500'))

interface route_t {
  path: string
  component: JSX.Element
  progress?: string
  hidden_error?: boolean
  hidden_footer?: boolean
}

export const routes: route_t[] = [
  {
    path: TO_INTRO_S0,
    component: <IntroS0 />,
  },
  {
    path: TO_INTRO_S1,
    component: <IntroS1 />,
    progress: '15%',
  },
  {
    path: TO_INTRO_S2_OLD,
    component: <IntroS2Old />,
    progress: '30%',
  },
  {
    path: TO_INTRO_S2,
    component: <IntroS2 />,
    progress: '30%',
  },
  {
    path: TO_TRADI_S1,
    component: <TradiS1 />,
    progress: '40%',
  },
  {
    path: TO_TRADI_S2,
    component: <TradiS2 />,
    progress: '50%',
  },
  {
    path: TO_TRADI_S3,
    component: <TradiS3 />,
    progress: '60%',
  },
  {
    path: TO_TRADI_S4,
    component: <TradiS4 />,
    progress: '65%',
  },
  {
    path: TO_TRADI_S5,
    component: <TradiS5 />,
    progress: '70%',
  },
  {
    path: TO_FASTQ_S1,
    component: <FastqS1 />,
    progress: '40%',
    hidden_error: true,
  },
  {
    path: TO_GENER_S1,
    component: <GenerS1 />,
    progress: '85%',
  },
  {
    path: TO_GENER_S2,
    component: <GenerS2 />,
    progress: '100%',
  },
  {
    path: TO_GENER_S3,
    component: <GenerS3 />,
  },
  {
    path: TO_GENER_S4,
    component: <GenerS4 />,
  },
  {
    path: TO_COOKIE_POLICY_LIST,
    component: <CookiePolicy />,
  },
  {
    path: TO_ACCESSIBILITY,
    component: <Accessibility />,
  },
  {
    path: TO_ERROR_404,
    component: <Error404 />,
    hidden_footer: true,
  },
  {
    path: TO_ERROR_500,
    component: <Error500 />,
    hidden_footer: true,
  },
]
